import i18next from 'i18next'

const getLocaleAmount = ({ amount }) => {
  const numberAmount = Math.abs(amount)
  return numberAmount.toLocaleString(i18next.language)
}

const getCurrency = ({ amount }) => {
  const localeAmount = getLocaleAmount({ amount: amount })
  return i18next.t('common__currency', { amount: localeAmount })
}

export { getLocaleAmount, getCurrency }
